// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/tenant/v1/tenant.proto" (package "c1.api.tenant.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AuthBackends } from "../../accounts/v1/accounts";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.tenant.v1.IntrospectRequest
 */
export interface IntrospectRequest {
}
/**
 * @generated from protobuf message c1.api.tenant.v1.IntrospectResponse
 */
export interface IntrospectResponse {
    /**
     * @generated from protobuf field: string domain = 1;
     */
    domain: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accounts.v1.AuthBackends auth_backend = 5;
     */
    authBackend: AuthBackends;
    /**
     * @generated from protobuf field: string auth_domain = 6;
     */
    authDomain: string;
    /**
     * @generated from protobuf field: c1.api.tenant.v1.IntrospectResponse.TenantLifecycle lifecycle = 7;
     */
    lifecycle: IntrospectResponse_TenantLifecycle;
}
/**
 * @generated from protobuf enum c1.api.tenant.v1.IntrospectResponse.TenantLifecycle
 */
export enum IntrospectResponse_TenantLifecycle {
    /**
     * @generated from protobuf enum value: TENANT_LIFECYCLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TENANT_LIFECYCLE_ADMIN_DISABLED = 1;
     */
    ADMIN_DISABLED = 1,
    /**
     * @generated from protobuf enum value: TENANT_LIFECYCLE_LIVE_POC = 2;
     */
    LIVE_POC = 2,
    /**
     * @generated from protobuf enum value: TENANT_LIFECYCLE_LIVE_PRODUCTION = 3;
     */
    LIVE_PRODUCTION = 3,
    /**
     * @generated from protobuf enum value: TENANT_LIFECYCLE_LIVE_SANDBOX = 4;
     */
    LIVE_SANDBOX = 4,
    /**
     * @generated from protobuf enum value: TENANT_LIFECYCLE_PENDING_INVITE_ACCEPT = 5;
     */
    PENDING_INVITE_ACCEPT = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectRequest$Type extends MessageType<IntrospectRequest> {
    constructor() {
        super("c1.api.tenant.v1.IntrospectRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tenant.v1.IntrospectRequest
 */
export const IntrospectRequest = new IntrospectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectResponse$Type extends MessageType<IntrospectResponse> {
    constructor() {
        super("c1.api.tenant.v1.IntrospectResponse", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "auth_backend", kind: "enum", T: () => ["c1.api.accounts.v1.AuthBackends", AuthBackends] },
            { no: 6, name: "auth_domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "lifecycle", kind: "enum", T: () => ["c1.api.tenant.v1.IntrospectResponse.TenantLifecycle", IntrospectResponse_TenantLifecycle, "TENANT_LIFECYCLE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tenant.v1.IntrospectResponse
 */
export const IntrospectResponse = new IntrospectResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.tenant.v1.Tenant
 */
export const Tenant = new ServiceType("c1.api.tenant.v1.Tenant", [
    { name: "Introspect", options: { "authz.method": { role: "REFLECTION" } }, I: IntrospectRequest, O: IntrospectResponse }
]);
